import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BoolNumber, FALSE, TRUE } from 'base/utils/soccerHelpers';

type SetBetMatchPayloadAction = PayloadAction<{
    betLinesIndex: number;
    matchIndex: number;
    pool: number;
    value: BoolNumber;
}>;

const initialState = {
    betMatchLines: [] as BoolNumber[][][],
};
export const soccerStoreSlice = createSlice({
    name: 'soccerPlayStore',
    initialState,
    reducers: {
        initializeBetMatchLine: (state, action: PayloadAction<{ matchCount: number; extraMatchCount: number }>) => {
            const { matchCount, extraMatchCount } = action.payload;
            const lineMatches = [...Array(matchCount)].map(() => [...Array(3)].map(() => FALSE));
            const lineExtraMatches = [...Array(extraMatchCount)].map(() => [...Array(8)].map(() => FALSE));
            state.betMatchLines.push([...lineMatches, ...lineExtraMatches]);
        },
        setBetMatch: (state, action: SetBetMatchPayloadAction) => {
            const { betLinesIndex, matchIndex, pool, value } = action.payload;

            let betMatchLine = state.betMatchLines[state.betMatchLines.length - 1];
            if (betLinesIndex !== null) {
                betMatchLine = state.betMatchLines[betLinesIndex];
            }

            const betsCount = betMatchLine[matchIndex].filter((bet) => bet === TRUE).length;

            // Extra bets
            if (matchIndex === 14) {
                const extraBetsCount = betMatchLine[matchIndex].slice(0, 4).filter((bet) => bet === TRUE).length;
                const extraBetsSecondCount = betMatchLine[matchIndex].slice(4).filter((bet) => bet === TRUE).length;

                // only 1 bet for group per line
                if (pool < 4) {
                    if (extraBetsCount < 1 || !value) {
                        betMatchLine[matchIndex][pool] = value;
                    }
                } else if (extraBetsSecondCount < 1 || !value) {
                    betMatchLine[matchIndex][pool] = value;
                }

                return;
            }

            // max 2 bets per line
            if (betsCount < 2 || !value) {
                betMatchLine[matchIndex][pool] = value;
            }

            state.betMatchLines[betLinesIndex ?? state.betMatchLines.length - 1] = betMatchLine;
        },
        setBetMatchLines: (state, action: PayloadAction<{ lines: BoolNumber[][][] }>) => {
            state.betMatchLines = action.payload.lines;
        },
        quickPickBetMatchLines: (state, action: PayloadAction<{ betLinesIndex: number }>) => {
            const { betLinesIndex } = action.payload;
            const linesIndex = betLinesIndex ?? state.betMatchLines.length - 1;

            state.betMatchLines[linesIndex] = state.betMatchLines[linesIndex].map((matchLine, index) => {
                const newMatchLine = matchLine.map(() => FALSE);

                if (index === 14) {
                    newMatchLine[Math.floor(Math.random() * 4)] = TRUE;
                    newMatchLine[Math.floor(Math.random() * 4 + 4)] = TRUE;
                } else {
                    newMatchLine[Math.floor(Math.random() * 3)] = TRUE;
                }

                return newMatchLine;
            });
        },
        clearPickedBetMatchLine: (state, action: PayloadAction<{ betLinesIndex: number }>) => {
            const { betLinesIndex } = action.payload;
            const linesIndex = betLinesIndex ?? state.betMatchLines.length - 1;

            if (state.betMatchLines.length > 1 && state.betMatchLines.length - 1 !== linesIndex) {
                state.betMatchLines.splice(linesIndex, 1);
            } else {
                state.betMatchLines[linesIndex] = state.betMatchLines[linesIndex].map((matchLine) =>
                    matchLine.map(() => FALSE)
                );
            }
        },
    },
});

export const {
    initializeBetMatchLine,
    setBetMatch,
    setBetMatchLines,
    quickPickBetMatchLines,
    clearPickedBetMatchLine,
} = soccerStoreSlice.actions;
